export * from './entities.module';
export * from './entity-detail/entity-detail.component';
export * from './entity-list/entity-list.component';
export * from './entity-route-resolver';
